/* =================================================================
   GBS Product Page — CANBarra Integration
   -----------------------------------------------------------------
   Prompt 1: CANBarra recommendation panel on loom product pages.
             Appears when an A/C-containing variant is selected.
   Prompt 2: Required vehicle-details form on the CANBarra product page.
================================================================= */

(function () {
  'use strict';

  var CANBARRA_HANDLE = 'canbarra-module-by-can-solutions';

  var productData   = null;   /* parsed from #gbs-product-data */
  var canbarraData  = null;   /* fetched from /products/canbarra-module-…js */

  /* ================================================================
     INIT
  ================================================================ */
  function init() {
    var dataEl = document.getElementById('gbs-product-data');
    if (!dataEl) return;
    try { productData = JSON.parse(dataEl.textContent); }
    catch (e) { return; }

    if (productData.is_loom)     initLoomPage();
    if (productData.is_canbarra) initCanbarraPage();
  }

  /* ================================================================
     LOOM PRODUCT PAGE  (Prompt 1)
  ================================================================ */
  function initLoomPage() {
    var panel = document.getElementById('gbs-canbarra-panel');
    if (!panel) return;

    /* Fetch CANBarra price — separate standard vs ZF variant prices */
    fetch('/products/' + CANBARRA_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        canbarraData = data;
        if (data.variants && data.variants.length > 0) {
          /* Identify the ZF variant and the standard variant by title */
          var standardVariant = data.variants[0];
          var zfVariant       = data.variants[0]; /* fallback if no ZF variant found */
          for (var i = 0; i < data.variants.length; i++) {
            if (data.variants[i].title.toLowerCase().indexOf('zf') !== -1) {
              zfVariant = data.variants[i];
            } else {
              standardVariant = data.variants[i];
            }
          }
          var priceEl = document.getElementById('gbs-cb-price');
          if (priceEl) priceEl.textContent = formatMoney(standardVariant.price);
          var zfPriceEl = document.getElementById('gbs-zf-cb-price');
          if (zfPriceEl) zfPriceEl.textContent = formatMoney(zfVariant.price);
        }
      })
      .catch(function () {});

    /* Listen for variant changes via Dawn's pub/sub system (fires after
       AJAX swap completes — most reliable trigger for panel updates) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        updateLoomPanel();
      });
    }

    /* Fallback: DOM change events — covers cases where pub/sub isn't available
       or the radio fires before product-info publishes (e.g. no AJAX) */
    document.addEventListener('change', onLoomOptionChange, true);

    /* Initial check (variant may already be AC/ZF on page load) */
    setTimeout(updateLoomPanel, 100);

    /* CANBarra add-on toggle */
    var cbToggle = document.getElementById('gbs-cb-toggle');
    if (cbToggle) {
      cbToggle.addEventListener('change', function () {
        var fieldsEl = document.getElementById('gbs-cb-fields');
        if (fieldsEl) fieldsEl.hidden = !cbToggle.checked;
        clearLoomErrors();
      });
    }

    /* Clear individual field errors on input */
    ['gbs-cb-makemodel', 'gbs-cb-year', 'gbs-cb-engine', 'gbs-cb-trans'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', function () {
        el.classList.remove('gbs-cp__field--error');
        clearLoomErrors();
      });
    });

    /* ZF panel field error clearing */
    if (productData.has_zf) {
      ['gbs-zf-cb-makemodel', 'gbs-zf-cb-year', 'gbs-zf-cb-engine', 'gbs-zf-cb-trans'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.addEventListener('input', function () {
          el.classList.remove('gbs-cp__field--error');
          clearZfErrors();
        });
      });
    }

    /* Intercept ATC form submit (capture phase so our handler runs first) */
    var atcForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (atcForm) atcForm.addEventListener('submit', handleLoomSubmit, true);
  }

  function onLoomOptionChange(e) {
    /* Trigger on any radio/select change inside variant-selects */
    if (e.target.closest && e.target.closest('variant-selects')) {
      setTimeout(updateLoomPanel, 50);
    }
  }

  function isZfVariant() {
    if (!productData || !productData.has_zf) return false;
    var vsEl = document.querySelector('variant-selects');
    if (vsEl) {
      var checkedRadios = vsEl.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < checkedRadios.length; i++) {
        if (checkedRadios[i].value.toLowerCase().indexOf('zf') !== -1) return true;
      }
      var dvEl = vsEl.querySelector('script[data-selected-variant]');
      if (dvEl) {
        try {
          var sv = JSON.parse(dvEl.textContent);
          if (sv && sv.title && sv.title.toLowerCase().indexOf('zf') !== -1) return true;
          if (sv && Array.isArray(sv.options)) {
            for (var j = 0; j < sv.options.length; j++) {
              if (typeof sv.options[j] === 'string' && sv.options[j].toLowerCase().indexOf('zf') !== -1) return true;
            }
          }
        } catch (err) {}
      }
      var selects = vsEl.querySelectorAll('select');
      for (var k = 0; k < selects.length; k++) {
        if (selects[k].value.toLowerCase().indexOf('zf') !== -1) return true;
      }
    }
    var variantInput = document.querySelector('.product-variant-id');
    if (variantInput && productData && productData.variants) {
      var vid = parseInt(variantInput.value, 10);
      for (var m = 0; m < productData.variants.length; m++) {
        if (productData.variants[m].id === vid) {
          return productData.variants[m].title.toLowerCase().indexOf('zf') !== -1;
        }
      }
    }
    return false;
  }

  function isAcVariant() {
    /* 1. Check any currently-checked radio inside variant-selects whose value contains "A/C".
          This works for both pill/card style (gbs-product-hero) and standard Dawn pickers. */
    var vsEl = document.querySelector('variant-selects');
    if (vsEl) {
      var checkedRadios = vsEl.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < checkedRadios.length; i++) {
        if (checkedRadios[i].value.toLowerCase().indexOf('a/c') !== -1) return true;
      }
      /* Also parse the data-selected-variant JSON Dawn keeps inside variant-selects */
      var dvEl = vsEl.querySelector('script[data-selected-variant]');
      if (dvEl) {
        try {
          var sv = JSON.parse(dvEl.textContent);
          if (sv && sv.title && sv.title.toLowerCase().indexOf('a/c') !== -1) return true;
          if (sv && Array.isArray(sv.options)) {
            for (var j = 0; j < sv.options.length; j++) {
              if (typeof sv.options[j] === 'string' && sv.options[j].toLowerCase().indexOf('a/c') !== -1) return true;
            }
          }
        } catch (err) {}
      }
      /* Check selects */
      var selects = vsEl.querySelectorAll('select');
      for (var k = 0; k < selects.length; k++) {
        if (selects[k].value.toLowerCase().indexOf('a/c') !== -1) return true;
      }
    }

    /* 2. Fallback: match variant ID against productData.variants list */
    var variantInput = document.querySelector('.product-variant-id');
    if (variantInput && productData && productData.variants) {
      var vid = parseInt(variantInput.value, 10);
      for (var m = 0; m < productData.variants.length; m++) {
        if (productData.variants[m].id === vid) {
          return productData.variants[m].title.toLowerCase().indexOf('a/c') !== -1;
        }
      }
    }

    return false;
  }

  function updateLoomPanel() {
    var hasAc = isAcVariant();
    var hasZf = isZfVariant();

    /* AC panel */
    var panel = document.getElementById('gbs-canbarra-panel');
    if (panel) {
      if (!hasAc) {
        if (!panel.hidden) {
          panel.hidden = true;
          var cbToggle = document.getElementById('gbs-cb-toggle');
          if (cbToggle) cbToggle.checked = false;
          var fieldsEl = document.getElementById('gbs-cb-fields');
          if (fieldsEl) fieldsEl.hidden = true;
          clearLoomErrors();
        }
      } else {
        panel.hidden = false;
      }
    }

    /* ZF panel */
    var zfPanel = document.getElementById('gbs-zf-canbarra-panel');
    if (zfPanel) {
      if (!hasZf) {
        if (!zfPanel.hidden) {
          zfPanel.hidden = true;
          clearZfErrors();
        }
      } else {
        zfPanel.hidden = false;
      }
    }
  }

  function handleLoomSubmit(e) {
    /* ZF panel — CANBarra always required when visible */
    var zfPanel = document.getElementById('gbs-zf-canbarra-panel');
    if (zfPanel && !zfPanel.hidden) {
      handleZfSubmit(e);
      return;
    }

    var panel = document.getElementById('gbs-canbarra-panel');
    if (!panel || panel.hidden) return; /* not applicable */

    var cbToggle = document.getElementById('gbs-cb-toggle');
    if (!cbToggle || !cbToggle.checked) return; /* CANBarra not requested, let normal submit proceed */

    /* CANBarra is requested — take over submission */
    e.preventDefault();
    e.stopImmediatePropagation();

    /* Validate required fields */
    var errors = validateLoomFields();
    if (errors.length > 0) {
      showLoomErrors(errors);
      return;
    }

    /* Lock submit button */
    var submitBtn = document.getElementById('ProductSubmitButton-' + (productData.section_id || ''));
    if (!submitBtn) submitBtn = document.querySelector('.product-form__submit');
    var origText = submitBtn ? (submitBtn.querySelector('span') ? submitBtn.querySelector('span').textContent : submitBtn.textContent) : 'Add to cart';
    if (submitBtn) {
      submitBtn.disabled = true;
      if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = 'Adding to cart…';
      else submitBtn.textContent = 'Adding to cart…';
    }

    /* Get loom variant ID — .product-variant-id exists in main-product.liquid (buy-buttons snippet);
       gbs-product-hero.liquid uses a plain input[name="id"] inside product-form */
    var variantInput = document.querySelector('.product-variant-id')
                    || document.querySelector('product-form input[name="id"]')
                    || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var loomVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!loomVariantId) {
      restoreLoomBtn(submitBtn, origText);
      showLoomError('Could not determine product variant. Please try again.');
      return;
    }

    /* Get CANBarra variant ID */
    var canbarraVariantId = canbarraData && canbarraData.variants && canbarraData.variants.length > 0
      ? canbarraData.variants[0].id
      : null;
    if (!canbarraVariantId) {
      restoreLoomBtn(submitBtn, origText);
      showLoomError('CANBarra product data not loaded. Please refresh and try again.');
      return;
    }

    var makeModel = document.getElementById('gbs-cb-makemodel').value.trim();
    var year      = document.getElementById('gbs-cb-year').value.trim();
    var engine    = document.getElementById('gbs-cb-engine').value.trim();
    var trans     = document.getElementById('gbs-cb-trans').value.trim();
    var loomTitle = productData.title || '';
    var qtyInput  = document.querySelector('.quantity__input');
    var qty       = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    /* Check for CANBarra already in cart (duplicate prevention) */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var alreadyInCart = cart.items.some(function (item) {
          return item.variant_id === canbarraVariantId;
        });
        var items = [
          { id: loomVariantId, quantity: qty }
        ];
        if (!alreadyInCart) {
          items.push({
            id: canbarraVariantId,
            quantity: 1,
            properties: {
              'Vehicle Make and Model': makeModel,
              'Vehicle Year':           year,
              'Factory Engine':         engine,
              'Factory Transmission':   trans,
              'Recommended With Loom':  loomTitle
            }
          });
        }
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw d; });
        return res.json();
      })
      .then(function () {
        if (submitBtn) {
          if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = 'Added — opening cart…';
          else submitBtn.textContent = 'Added — opening cart…';
        }
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('GBS CANBarra loom ATC error:', err);
        restoreLoomBtn(submitBtn, origText);
        var msg = (err && err.description) ? err.description : 'Something went wrong adding items to cart. Please try again.';
        showLoomError(msg);
      });
  }

  function validateLoomFields() {
    var fields = [
      { id: 'gbs-cb-makemodel', label: 'Vehicle Make and Model' },
      { id: 'gbs-cb-year',      label: 'Vehicle Year' },
      { id: 'gbs-cb-engine',    label: 'Factory Engine' },
      { id: 'gbs-cb-trans',     label: 'Factory Transmission' }
    ];
    var errors = [];
    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      if (!el || !el.value.trim()) {
        errors.push(f);
        if (el) el.classList.add('gbs-cp__field--error');
      } else {
        if (el) el.classList.remove('gbs-cp__field--error');
      }
    });
    return errors;
  }

  function showLoomErrors(errors) {
    var errEl = document.getElementById('gbs-cb-errors');
    if (errEl) {
      errEl.textContent = 'Please complete required fields: ' + errors.map(function (e) { return e.label; }).join(', ') + '.';
      errEl.hidden = false;
    }
    if (errors.length > 0) {
      var first = document.getElementById(errors[0].id);
      if (first) { first.focus(); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  }

  function showLoomError(msg) {
    var errEl = document.getElementById('gbs-cb-errors');
    if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
  }

  function clearLoomErrors() {
    var errEl = document.getElementById('gbs-cb-errors');
    if (errEl) errEl.hidden = true;
  }

  function restoreLoomBtn(btn, text) {
    if (!btn) return;
    btn.disabled = false;
    if (btn.querySelector('span')) btn.querySelector('span').textContent = text;
    else btn.textContent = text;
  }

  /* ================================================================
     ZF PANEL — Required CANBarra for ZF Automatic variants
  ================================================================ */
  function handleZfSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var errors = validateZfFields();
    if (errors.length > 0) {
      showZfErrors(errors);
      return;
    }

    var submitBtn = document.getElementById('ProductSubmitButton-' + (productData.section_id || ''));
    if (!submitBtn) submitBtn = document.querySelector('.product-form__submit');
    var origText = submitBtn ? (submitBtn.querySelector('span') ? submitBtn.querySelector('span').textContent : submitBtn.textContent) : 'Add to cart';
    if (submitBtn) {
      submitBtn.disabled = true;
      if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = 'Adding to cart…';
      else submitBtn.textContent = 'Adding to cart…';
    }

    var variantInput = document.querySelector('.product-variant-id')
                    || document.querySelector('product-form input[name="id"]')
                    || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var loomVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!loomVariantId) {
      restoreLoomBtn(submitBtn, origText);
      showZfError('Could not determine product variant. Please try again.');
      return;
    }

    /* ZF builds need the ZF-specific CANBarra variant */
    var canbarraVariantId = null;
    if (canbarraData && canbarraData.variants && canbarraData.variants.length > 0) {
      for (var vi = 0; vi < canbarraData.variants.length; vi++) {
        if (canbarraData.variants[vi].title.toLowerCase().indexOf('zf') !== -1) {
          canbarraVariantId = canbarraData.variants[vi].id;
          break;
        }
      }
      /* Fallback to first variant if no ZF variant found */
      if (!canbarraVariantId) canbarraVariantId = canbarraData.variants[0].id;
    }
    if (!canbarraVariantId) {
      restoreLoomBtn(submitBtn, origText);
      showZfError('CANBarra product data not loaded. Please refresh and try again.');
      return;
    }

    var makeModel = document.getElementById('gbs-zf-cb-makemodel').value.trim();
    var year      = document.getElementById('gbs-zf-cb-year').value.trim();
    var engine    = document.getElementById('gbs-zf-cb-engine').value.trim();
    var trans     = document.getElementById('gbs-zf-cb-trans').value.trim();
    var loomTitle = productData.title || '';
    var qtyInput  = document.querySelector('.quantity__input');
    var qty       = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var alreadyInCart = cart.items.some(function (item) {
          return item.variant_id === canbarraVariantId;
        });
        var items = [{ id: loomVariantId, quantity: qty }];
        if (!alreadyInCart) {
          items.push({
            id: canbarraVariantId,
            quantity: 1,
            properties: {
              'Vehicle Make and Model': makeModel,
              'Vehicle Year':           year,
              'Factory Engine':         engine,
              'Factory Transmission':   trans,
              'Recommended With Loom':  loomTitle,
              'ZF Body Loom':           'Customer to supply — must be sent to GBS before harness can be built'
            }
          });
        }
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw d; });
        return res.json();
      })
      .then(function () {
        if (submitBtn) {
          if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = 'Added — opening cart…';
          else submitBtn.textContent = 'Added — opening cart…';
        }
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('GBS ZF CANBarra loom ATC error:', err);
        restoreLoomBtn(submitBtn, origText);
        var msg = (err && err.description) ? err.description : 'Something went wrong adding items to cart. Please try again.';
        showZfError(msg);
      });
  }

  function validateZfFields() {
    var fields = [
      { id: 'gbs-zf-cb-makemodel', label: 'Vehicle Make and Model' },
      { id: 'gbs-zf-cb-year',      label: 'Vehicle Year' },
      { id: 'gbs-zf-cb-engine',    label: 'Factory Engine' },
      { id: 'gbs-zf-cb-trans',     label: 'Factory Transmission' }
    ];
    var errors = [];
    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      if (!el || !el.value.trim()) {
        errors.push(f);
        if (el) el.classList.add('gbs-cp__field--error');
      } else {
        if (el) el.classList.remove('gbs-cp__field--error');
      }
    });
    return errors;
  }

  function showZfErrors(errors) {
    var errEl = document.getElementById('gbs-zf-cb-errors');
    if (errEl) {
      errEl.textContent = 'Please complete required fields: ' + errors.map(function (e) { return e.label; }).join(', ') + '.';
      errEl.hidden = false;
    }
    if (errors.length > 0) {
      var first = document.getElementById(errors[0].id);
      if (first) { first.focus(); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  }

  function showZfError(msg) {
    var errEl = document.getElementById('gbs-zf-cb-errors');
    if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
  }

  function clearZfErrors() {
    var errEl = document.getElementById('gbs-zf-cb-errors');
    if (errEl) errEl.hidden = true;
  }

  /* ================================================================
     CANBARRA STANDALONE PRODUCT PAGE  (Prompt 2)
  ================================================================ */
  function initCanbarraPage() {
    var fieldsForm = document.getElementById('gbs-canbarra-required-fields');
    if (!fieldsForm) return;

    /* Clear errors on field input */
    ['gbs-cbp-makemodel', 'gbs-cbp-year', 'gbs-cbp-engine', 'gbs-cbp-trans'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', function () {
        el.classList.remove('gbs-cp__field--error');
        clearCbpErrors();
      });
    });

    /* Intercept ATC submit — validate, then AJAX add with properties */
    var atcForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (atcForm) atcForm.addEventListener('submit', handleCanbarraPageSubmit, true);
  }

  function handleCanbarraPageSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var errors = validateCbpFields();
    if (errors.length > 0) {
      showCbpErrors(errors);
      return;
    }

    var submitBtn = document.querySelector('.gbs-ph__atc')
                 || document.querySelector('.product-form__submit');
    var origSpan  = submitBtn && submitBtn.querySelector('span');
    var origText  = origSpan ? origSpan.textContent : (submitBtn ? submitBtn.textContent : 'Add to cart');
    if (submitBtn) {
      submitBtn.disabled = true;
      if (origSpan) origSpan.textContent = 'Adding to cart…';
      else submitBtn.textContent = 'Adding to cart…';
    }

    var variantInput  = document.querySelector('.product-variant-id')
                     || document.querySelector('product-form input[name="id"]')
                     || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var variantId     = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!variantId) {
      restoreCbpBtn(submitBtn, origSpan, origText);
      var errEl = document.getElementById('gbs-cbp-errors');
      if (errEl) { errEl.textContent = 'Could not determine product variant. Please try again.'; errEl.hidden = false; }
      return;
    }

    var makeModel = document.getElementById('gbs-cbp-makemodel').value.trim();
    var year      = document.getElementById('gbs-cbp-year').value.trim();
    var engine    = document.getElementById('gbs-cbp-engine').value.trim();
    var trans     = document.getElementById('gbs-cbp-trans').value.trim();
    var qtyInput  = document.querySelector('.quantity__input');
    var qty       = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({
        items: [{
          id:         variantId,
          quantity:   qty,
          properties: {
            'Vehicle Make and Model': makeModel,
            'Vehicle Year':           year,
            'Factory Engine':         engine,
            'Factory Transmission':   trans
          }
        }]
      })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw d; });
      return res.json();
    })
    .then(function () {
      if (submitBtn) {
        if (origSpan) origSpan.textContent = 'Added — opening cart…';
        else submitBtn.textContent = 'Added — opening cart…';
      }
      openCartDrawer();
    })
    .catch(function (err) {
      console.error('GBS CANBarra page ATC error:', err);
      restoreCbpBtn(submitBtn, origSpan, origText);
      var errEl = document.getElementById('gbs-cbp-errors');
      if (errEl) {
        errEl.textContent = (err && err.description) ? err.description : 'Something went wrong. Please try again.';
        errEl.hidden = false;
      }
    });
  }

  function validateCbpFields() {
    var fields = [
      { id: 'gbs-cbp-makemodel', label: 'Vehicle Make and Model' },
      { id: 'gbs-cbp-year',      label: 'Vehicle Year' },
      { id: 'gbs-cbp-engine',    label: 'Factory Engine' },
      { id: 'gbs-cbp-trans',     label: 'Factory Transmission' }
    ];
    var errors = [];
    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      if (!el || !el.value.trim()) {
        errors.push(f);
        if (el) el.classList.add('gbs-cp__field--error');
      } else {
        if (el) el.classList.remove('gbs-cp__field--error');
      }
    });
    return errors;
  }

  function showCbpErrors(errors) {
    var errEl = document.getElementById('gbs-cbp-errors');
    if (errEl) {
      errEl.textContent = 'Please complete required fields: ' + errors.map(function (e) { return e.label; }).join(', ') + '.';
      errEl.hidden = false;
    }
    if (errors.length > 0) {
      var first = document.getElementById(errors[0].id);
      if (first) { first.focus(); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  }

  function clearCbpErrors() {
    var errEl = document.getElementById('gbs-cbp-errors');
    if (errEl) errEl.hidden = true;
  }

  function restoreCbpBtn(btn, span, text) {
    if (!btn) return;
    btn.disabled = false;
    if (span) span.textContent = text;
    else btn.textContent = text;
  }

  /* ================================================================
     UTILITIES
  ================================================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function openCartDrawer() {
    var cartBtn = document.querySelector('[aria-controls="cart-drawer"]');
    if (cartBtn) { cartBtn.click(); return; }
    window.location.href = '/cart';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
